module.exports = __webpack_public_path__ + "img/idCard-preview.e28b4d0c.png";